import React from 'react';
import "./VideoGrid.css";
import Video from "./Video";
import firebase from '../Firebase';

class VideoList extends React.Component {
  constructor(props) {
    super(props);
    this.state = { videos: []};
    this.props = props;
  }

  componentDidMount() {
    firebase.auth().onAuthStateChanged((user) => {
      if (user != null) {
        const db = firebase.firestore();
        const uid = firebase.auth().currentUser.uid;
        const app = this;

        this.unsubscribe = db.collection("users").doc(uid).collection("videos")
          .onSnapshot((snapshot) => {
            snapshot.docChanges().forEach(function (change) {
              if (change.type === "added") {
                console.log("New video: ", change.doc.data());
                var videoData = {id: change.doc.id, data: change.doc.data()}
                const newVideoList = app.state.videos.concat(videoData);
                app.setState({videos: newVideoList});
              }
              if (change.type === "modified") {
                console.log("Modified video: ", change.doc.data());
                var video = app.state.videos.filter(video => video.id == change.doc.id)[0];
                video['data'] = change.doc.data();
                app.setState({videos: app.state.videos});
              }
              if (change.type === "removed") {
                console.log("Removed video: ", change.doc.data());
                var newVideoList  = app.state.videos.filter(video => video.id != change.doc.id);
                app.setState({videos: newVideoList});
              }
            });
          });
      }
    });
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  render() {

    const videos = [];

    for(const [index, value] of this.state.videos.entries()){
      videos.push(<Video key={index} vid={value.id} viddata={value.data} />);
    }

    return (
      <div className="video-grid">
        {videos}
      </div>
    )
  }
}

export default VideoList;